import _styled from "styled-components";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useContext } from 'react';
import Symbol from '../symbol/Symbol';
import { modalCloseStyle } from './ModalClose.style';
import { ModalContext } from './ModalContext';
import { ICON_CLOSE } from '../../icons';
export let ModalCloseVariant = /*#__PURE__*/function (ModalCloseVariant) {
  ModalCloseVariant["BASE"] = "BASE";
  ModalCloseVariant["OVERLAY"] = "OVERLAY";
  return ModalCloseVariant;
}({});
const ModalClose = _ref => {
  let {
    variant = ModalCloseVariant.BASE,
    ...rest
  } = _ref;
  const {
    onCloseHandler
  } = useContext(ModalContext);
  return /*#__PURE__*/React.createElement(_StyledButton, _extends({
    $variant: variant,
    onClick: onCloseHandler,
    type: "button"
  }, rest), /*#__PURE__*/React.createElement(Symbol, {
    path: ICON_CLOSE,
    size: 24
  }));
};
export default ModalClose;
var _StyledButton = _styled("button").withConfig({
  displayName: "ModalClose___StyledButton",
  componentId: "sc-xubz82-0"
})(["", ""], modalCloseStyle);
//# sourceMappingURL=ModalClose.js.map